"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createLogger = _interopRequireDefault(require("winston/dist/winston/create-logger"));
var _logform = require("logform");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const logger = (0, _createLogger.default)({
  format: _logform.format.simple(),
  level: process.env.DEBUG ? 'silly' : 'info'
});
var _default = exports.default = logger;